import { Context } from '@nuxt/types'

declare global {
  interface Window {
    $workbox: Promise<any>
  }
}

export default async function (_: Context) {
  const workbox = await window.$workbox

  if (!workbox) {
    console.debug("Workbox couldn't be loaded.") // eslint-disable-line
    return
  }

  workbox.addEventListener('installed', (event: any) => {
    console.log(event.isUpdate) // eslint-disable-line

    if (event.isUpdate === true) {
      console.debug('There is an update for the PWA') // eslint-disable-line
      let idleTime = 0
      const idleInterval = setInterval(() => {
        idleTime++
        if (idleTime > 3) {
          clearInterval(idleInterval)
          console.debug('There is an update for the PWA, reloading...') // eslint-disable-line
          window.location.reload()
        }
      }, 1000)
      document.addEventListener('mousemove', function () {
        idleTime = 0
      })
      document.addEventListener('keypress', function () {
        idleTime = 0
      })
      window.addEventListener('scroll', function () {
        idleTime = 0
      })
      return
    }

    console.debug('The PWA is on the latest version.') // eslint-disable-line
  })
}
